// Home.jsx
import React from "react";
import "./Home.css";
import { useEffect } from 'react';


const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="container">
      <h1 className="heading">
        Shaping bright futures with excellence at
        <span className="highlight"> Oxford Convent English Medium School</span>
      </h1>
      <p className="paragraph">
        At Oxford Convent English Medium School, we believe that education is the
        key to unlocking potential and transforming lives. Our school is committed
        to providing a nurturing and dynamic learning environment where students are
        encouraged to dream big, think critically, and grow holistically. With a strong
        focus on academic excellence, personal development, and values-based education,
        we prepare young minds to face the challenges of a rapidly changing world with
        confidence and compassion.
      </p>
      <p className="paragraph">
        Through innovative teaching methods, a supportive community, and a wide range
        of co-curricular activities, we aim to empower every student to achieve their
        full potential and make meaningful contributions to society. Join us on this
        journey of learning, growth, and excellence as we shape the leaders of tomorrow.
      </p>
    </div>
  );
};
export default Home;